import { useState, useEffect, useCallback } from 'react'
import type { IntegrationSummary } from '../types/index'
import { getIntegrations } from '../services/integrationsApi'

export function useIntegrations(workspaceId: string) {
  const [integrations, setIntegrations] = useState<IntegrationSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async () => {
    try {
      setLoading(true)
      const data = await getIntegrations(workspaceId)
      setIntegrations(data)
      setError(null)
    } catch {
      setError('Failed to load integrations')
    } finally {
      setLoading(false)
    }
  }, [workspaceId])

  useEffect(() => { refetch() }, [refetch])

  return { integrations, loading, error, refetch }
}
